<!-- <i title="{{'status_indicator.tooltip_lbl.error' | translate}}" *ngIf="status==StatusType.ERROR" class="fa-solid fa-circle-exclamation uw-status-indicator--error"></i> -->
@if (status==StatusType.ERROR) {
  <mat-icon  class="uw-status-indicator--error">error</mat-icon>
}
@if (status==StatusType.SUCCESS) {
  <mat-icon  class="uw-status-indicator--success">check_circle</mat-icon>
}
@if (status==StatusType.CANCELLED) {
  <mat-icon  class="uw-status-indicator--cancelled">cancel</mat-icon>
}
@if (status==StatusType.PROCESSING) {
  <mat-icon  class="uw-status-indicator--processing">restart_alt</mat-icon>
}

<!-- <i title="{{'status_indicator.tooltip_lbl.success' | translate}}" *ngIf="status==StatusType.SUCCESS" class="fa-solid fa-circle-check uw-status-indicator--success"></i>
<i title="{{'status_indicator.tooltip_lbl.cancelled' | translate}}" *ngIf="status==StatusType.CANCELLED" class="fa-solid fa-circle-xmark uw-status-indicator--cancelled"></i>
<i title="{{'status_indicator.tooltip_lbl.processing' | translate}}" *ngIf="status==StatusType.PROCESSING" class="fa-solid fa-spinner uw-status-indicator--processing"></i> -->
